import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { useQuery } from "@apollo/client"
import _ from "lodash"

import ROUTES from "../../../components/Routes/routesContants"

// Context
import { UserContext } from "../../../context/userContext"

// Prime
import { TabView, TabPanel } from "primereact/tabview"

// Comps
import ParticipantProfileBoxSmall from "../../../components/ParticipantProfileBoxSmall"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"

import { LoaderMedium } from "../../../components/Loaders"
import Form from "./Form"

import { MdStickyNote2 as IcoBlocks } from "react-icons/md"

// Queries
import { GET_ENGAGED_SERVICES_BY_PARTICIPANT } from "./queries"
import styles from "../../../styles/Participant-Profile.module.css"

export default function ParticipantEngagedServices() {
  const userCtx = useContext(UserContext)
  const participant_id = userCtx.current_participant_id

  const [blocks, setBlocks] = useState([])
  const [activeIndex, setActiveIndex] = useState(0)

  const navigate = useNavigate()

  const { loading, refetch } = useQuery(GET_ENGAGED_SERVICES_BY_PARTICIPANT, {
    variables: {
      participant_id,
      organization_id: userCtx.session.user.organization_id,
    },
    fetchPolicy: "network-only",
    skip: !userCtx,
    onCompleted: ({ participantProfile }) => {
      const sortBlocks = _.sortBy(participantProfile.blocks, ["index"])
      const renameBlocks = _.map(sortBlocks, (block) => {
        return {
          ...block,
          block_title: `${block.block_title}`.replace("Participant ", ""),
        }
      })
      setBlocks(renameBlocks)
    },
  })

  const handleBackBtn = () => {
    userCtx.changeParticipant(null)
    return navigate(ROUTES.PARTICIPANT_MYPARTICIPANTS)
  }

  if (loading) return <LoaderMedium />

  return (
    <div>
      <div className="layout-with-sidebar">
        <div className="sidebar">
          <ParticipantSidebar />
        </div>

        <div className="main-content">
          <ParticipantProfileBoxSmall />

          <div className={styles.tabs}>
            <TabView
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              {_.map(blocks, (block) => {
                return (
                  <TabPanel
                    key={block.block_name}
                    header={block.block_title}
                    id={block.block_name}
                  >
                    <Form
                      key={block.block_name}
                      participantId={participant_id}
                      blockName={block.block_name}
                      totalFields={block.total_fields}
                      triggerParticipantQuery={refetch}
                    />
                  </TabPanel>
                )
              })}
            </TabView>
          </div>
        </div>
      </div>
    </div>
  )
}
